export default function MissionVision() {
  return (
    <section className="py-20 max-w-[1400px] mx-auto px-6 lg:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-px bg-white/5 rounded-sm overflow-hidden">
        <div className="bg-[#0f0f0f] p-12">
          <div className="w-12 h-12 flex items-center justify-center rounded-sm bg-[#00ff88]/10 border border-[#00ff88]/20 mb-8">
            <i className="ri-focus-3-line text-[#00ff88] text-xl leading-none" />
          </div>
          <h2 className="text-2xl font-black text-white mb-4 font-syne">Our Mission</h2>
          <p className="text-white/50 text-base leading-relaxed font-inter">
            To empower gaming communities and creators worldwide by delivering world-class game development, infrastructure, and operational excellence. We exist to turn great game ideas into global phenomena and transform casual players into elite, organized guilds.
          </p>
        </div>
        <div className="bg-[#0f0f0f] p-12">
          <div className="w-12 h-12 flex items-center justify-center rounded-sm bg-[#f59e0b]/10 border border-[#f59e0b]/20 mb-8">
            <i className="ri-eye-line text-[#f59e0b] text-xl leading-none" />
          </div>
          <h2 className="text-2xl font-black text-white mb-4 font-syne">Our Vision</h2>
          <p className="text-white/50 text-base leading-relaxed font-inter">
            To become Southeast Asia's leading game development and guild operations company — a trusted partner for game studios, esports organizations, and gaming communities looking to compete at the highest level. We envision a future where every player has access to the tools to thrive.
          </p>
        </div>
      </div>
    </section>
  );
}
